import * as React from 'react'
import { useHomePageContentStore } from 'src/hooks/HomePageContent';
import { useState, useEffect } from 'react';
import useReduxState from 'src/hooks/useReduxState';

const Filter = () => {
    const [{ articleList }, { }] = useHomePageContentStore();
    const [filterList, setFilterList] = useState([]);
    const [updatedFilterList, setUpdatedFilterList] = useState([]);
    const [isFilterApply, setIsFilterApply] = useState(false);
    const [showFilterCount, setShowFilterCount] = useState(10);
    const [selectedFilterList, setSelectedFilterList] = useReduxState([], 'selectedFilterList');

    useEffect(() => {
        if (articleList && articleList.searchFacets && Object.entries(articleList.searchFacets).length > 0) {
            if (isFilterApply) {
                setUpdatedFilterList(articleList.searchFacets)
            } else {
                setFilterList(articleList.searchFacets)
            }
        }
    }, [articleList]);

    const setStatusOfFilter = (filterName) => {
        setIsFilterApply(true)
        let list = [...selectedFilterList]
        const found = list.some(el => el.filterName === filterName);
        if (!found) {
            list.push({ filterName: filterName })
        } else {
            list.splice(list.findIndex(v => v.filterName === filterName), 1);
        }

        setSelectedFilterList(list)
    }

    const clearAllFilter = () => {
        setSelectedFilterList([])
    }

    const getStatusOfForFieldActivated = (filterName) => {
        if (selectedFilterList &&
            selectedFilterList.length > 0
        ) {
            let status = false
            !status && selectedFilterList.map((v, i) => {
                if (v.filterName === filterName) {
                    status = true
                }
            })

            if (status) {
                return true
            } else {
                return false
            }

        }
        return false
    };

    return (
        <div className='mt-0 mt-md-5 m-b-20 newcontent-filter'>
            <div className='bs5 d-flex justify-content-between'>
                <span className='text-black font-bold mb-1 font-14'>NARROW YOUR RESULTS</span>
                <a className='cursor-pointer' onClick={() => clearAllFilter()}>Clear All</a>
            </div>
            {
                filterList && Object.entries(filterList).length > 0 &&
                <div className="panel-group" id="accordion">
                    {
                        Object.entries(filterList).map((v, i) => (
                            <div className="panel panel-default">
                                {
                                    v[1] && v[1].length > 0 &&
                                    <>
                                        <div className="panel-heading">
                                            <h4 className="panel-title">
                                                <a data-toggle="collapse" href={'#collapse' + i}>
                                                    {v[0]}</a>
                                            </h4>
                                        </div>
                                        <div id={'collapse' + i} className="panel-collapse collapse in">

                                            <div className="panel-body">
                                                {v[1].map((k, j) => (
                                                    <>
                                                        {j < showFilterCount &&
                                                            <div className="form-check">
                                                                <input type="checkbox" className="form-check-input"
                                                                    id={k.name} name={k.name}
                                                                    checked={getStatusOfForFieldActivated(k.filterName)}
                                                                    onChange={(e) => {
                                                                        setStatusOfFilter(k.filterName)
                                                                    }} />
                                                                <label className="form-check-label" htmlFor="customCheck"> {k.name}
                                                                    <span className="filter-count"> ({k.count})</span></label>
                                                            </div>
                                                        }
                                                    </>
                                                ))}

                                                {showFilterCount > 10 && v[1].length > 10 &&
                                                <div className='mt-2'>
                                                    <a href={void (0)} onClick={() => {
                                                        setShowFilterCount(10)
                                                    }} className='text-blue2 font-bold'>See Less</a>
                                                </div>
                                                }
                                                {showFilterCount <= 10 && v[1].length > 10 &&
                                                    <div className='mt-2'>
                                                        <a href={void (0)} onClick={() => {
                                                            setShowFilterCount(v[1].length)
                                                        }} className='text-blue2 font-bold'>See More</a>
                                                    </div>
                                                }
                                            </div>
                                            

                                        </div>
                                    </>
                                }

                            </div>
                        ))
                    }
                </div>
            }

        </div>
    )
}

export default Filter